<script lang="ts">
    export let msg = "";
	export let show = true;
</script>

{#if show}
    <div role="alert">
        <slot>{msg}</slot>
    </div>
{/if}

<style lang="scss">
    div {
        border-radius: 9px;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        color: white;
        background:#EE716F;
        margin-top:1rem;
        margin-bottom:1rem;
        padding: 12px 20px;

       //width: 100%
    }
</style>
